
<div class="row" class="justify-content-center display-flex">
  <div class="col-md-12 col-sm-12 col-xs-12 justify-content-center d-flex flex-wrap">
    <h1 class="title-content">R4.0 Platforms <span>components</span></h1>
    <div class="d-flex align-items-start w-100 justify-content-center">
      <div class="d-flex justify-content-center flex-wrap mt-3 link-mbottom col-8">
        <a href="{{hubUrl}}" class="item-box">
          <span class="hexagon"></span>
          <span class="icon hub">
            Platform Hub
          </span>
          <h6>Platform Hub</h6>
        </a>
        <a href="{{foundationPlatformUrl}}" class="item-box">
          <span class="hexagon"></span>
          <span class="icon data-management">
            Data Management
          </span>
          <h6>Data Management</h6>
        </a>
        <a href="{{dataCleansingUrl}}" class="item-box">
          <span class="hexagon"></span>
          <span class="icon data-cleansing">
            Data Cleansing
          </span>
          <h6>Data Cleansing</h6>
        </a>
        <a href="{{formulaBuilderUrl}}" class="item-box">
          <span class="hexagon"></span>
          <span class="icon builder">
           Formula Builder
          </span>
          <h6>Formula Builder</h6>
        </a>
        <a href="{{modelMgmtUrl}}" class="item-box">
          <span class="hexagon"></span>
          <span class="icon model-management">
            Model Management
          </span>
          <h6>Model Management</h6>
        </a>
        <a href="{{globals.flowsheetBuilderUrl}}" class="item-box">
          <span class="hexagon"></span>
          <span class="icon flowSheet-builder">
            FlowSheet Builder
          </span>
          <h6>FlowSheet Builder</h6>
        </a>
        <a href="{{globals.scenarioUrl}}" class="item-box d-none">
          <span class="hexagon"></span>
          <span class="icon scenarios">
            Scenarios
          </span>
          <h6>Scenarios</h6>
        </a>
        <a href="/" class="item-box d-none">
          <span class="hexagon"></span>
          <span class="icon monitoring">
            Monitoring
          </span>
          <h6>Monitoring</h6>
        </a>
        <a href="/" class="item-box d-none">
          <span class="hexagon"></span>
          <span class="icon gap-analysis">
            Gap Analysis
          </span>
          <h6>Gap Analysis</h6>
        </a>
      </div>
    </div>
    <div class="home-footer">
      <span>© 2024 TotalEnergies</span>
    </div>
  </div>
</div>
